import * as Yup from "yup";

const withdrawAmountPattern = /^[0-9]+(\.[0-9]{0,2})?$/;

export const getAvailableWithdrawalCents = (balance: number, totalBonuses: number) => {
  const availableCents = balance - totalBonuses;
  return availableCents > 0 ? availableCents : 0;
};

export const parseWithdrawAmountCents = (value?: string) => {
  if (!value || !withdrawAmountPattern.test(value)) return undefined;
  return Math.round(Number(value) * 100);
};

export const getDefaultWithdrawAmount = (availableWithdrawalCents: number) => {
  const defaultAmountCents = 5000;
  const normalizedAvailableCents = availableWithdrawalCents > 0 ? availableWithdrawalCents : 0;
  const amountCents = Math.min(normalizedAvailableCents, defaultAmountCents);

  return (amountCents / 100).toString();
};

export const createWithdrawAmountValidationSchema = (availableWithdrawalCents: number) => {
  return Yup.object({
    amount: Yup.string()
      .required("Amount is required")
      .matches(withdrawAmountPattern, "Enter a valid amount")
      .test("positive-amount", "Amount must be greater than $0", value => {
        if (!value || !withdrawAmountPattern.test(value)) return true;
        const amountCents = parseWithdrawAmountCents(value);
        return typeof amountCents === "number" && amountCents > 0;
      })
      .test("available-balance", "Amount is greater than your available balance", value => {
        if (!value || !withdrawAmountPattern.test(value)) return true;
        const amountCents = parseWithdrawAmountCents(value);
        if (typeof amountCents !== "number" || amountCents <= 0) return true;

        return amountCents <= availableWithdrawalCents;
      })
  });
};
